<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-4">
      <div class="col-md-6">
        <span class="d-flex justify-content-start align-items-center">
          <i
            (click)="goBack()"
            class="fa fa-arrow-left pointer mr-2"
            aria-hidden="true"></i>
          <h1 class="payment-history-title">Payment History</h1>
        </span>
      </div>
    </div>

    <ng-container *ngIf="loader">
      <div class="card" style="min-height: 50vh">
        <div class="card-body">
          <app-view-details-loader></app-view-details-loader>
        </div>
      </div>
    </ng-container>

    <div class="card" *ngIf="!loader">
      <div class="card-body" style="min-height: 50vh">
        <div style="display: flex; justify-content: space-between">
          <h3 class="invoice-number" *ngIf="invoiceNumber">
            Invoice Number: {{ invoiceNumber }}
          </h3>
          <h3
            class="invoice-number"
            *ngIf="invoiceNumber && invoiceCurrencyCode">
            Invoice Balance: {{ invoiceCurrencyCode }}
            <span>
              {{ invoiceBalance | number: constants.CURRENCY_FORMAT }}</span
            >
          </h3>
          <h3 class="invoice-number" *ngIf="paymentId">
            Payment ID: {{ paymentId }}
          </h3>
        </div>

        <table class="payment-table">
          <thead>
            <tr>
              <th>ID</th>

              <th>Attachment Date</th>
              <th>Attachment Type</th>
              <!-- Show either Invoice Number or Payment ID based on conditions -->
              <ng-container *ngIf="paymentId; else invoiceColumn">
                <th>Invoice Number</th>
              </ng-container>
              <ng-template #invoiceColumn>
                <th>Advance Payment ID</th>
              </ng-template>
              <!-- End of dynamic column -->
              <th>Amount Paid</th>
              <th>Remarks</th>
              <!-- <th>Invoice Balance</th> -->
              <ng-container
                *ngIf="
                  permissionService.hasPermission(
                    permissionConstants.DELETE_PAYMENT_FE
                  ) ||
                  permissionService.hasPermission(
                    permissionConstants.UPDATE_PAYMENT_FE
                  )
                ">
                <th>Action</th>
              </ng-container>
            </tr>
          </thead>

          <tbody>
            <!-- Show payment records if available -->
            <ng-container
              *ngIf="
                paymentDetails && paymentDetails.length > 0;
                else noPaymentRecords
              ">
              <tr *ngFor="let payment of paymentDetails">
                <td>{{ payment.id }}</td>
                <td>
                  {{ payment.attachmentDate | date: constants.DATE_FORMAT }}
                </td>
                <td>{{ payment.attachmentType }}</td>
                <!-- Show either Invoice Number or Payment ID based on conditions -->
                <ng-container *ngIf="paymentId; else invoiceCell">
                  <td>{{ payment.invoiceId?.invoiceNumber }}</td>
                </ng-container>
                <ng-template #invoiceCell>
                  <td>{{ payment.advancePaymentId }}</td>
                </ng-template>
                <!-- End of dynamic column -->
                <td>
                  {{ payment.paymentCurrency?.code }}
                  {{ payment.amountPaid | number: constants.CURRENCY_FORMAT }}
                </td>
                <td>{{ payment.remarks }}</td>
                <!-- <td>
                  {{
                    payment?.invoiceId?.quotation?.currency?.code ||
                      payment?.invoiceId?.serviceOrder?.currency?.code ||
                      payment?.invoiceId?.workOrders?.[0]?.currency?.code
                  }}
                  {{ payment.totalBalance | number: constants.CURRENCY_FORMAT }}
                </td> -->
                <ng-container
                  *ngIf="
                    permissionService.hasPermission(
                      permissionConstants.DELETE_PAYMENT_FE
                    ) ||
                    permissionService.hasPermission(
                      permissionConstants.UPDATE_PAYMENT_FE
                    )
                  ">
                  <td>
                    <ng-container
                      *ngIf="
                        permissionService.hasPermission(
                          permissionConstants.UPDATE_PAYMENT_FE
                        )
                      ">
                      <span
                        *ngIf="payment.attachmentType === 'PARTIAL'"
                        (click)="createPayment(payment)"
                        (keydown)="createPayment(payment)"
                        tabindex="0"
                        role="button">
                        <i class="fa fa-pencil edit-icon pointer"></i>
                      </span>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        permissionService.hasPermission(
                          permissionConstants.DELETE_PAYMENT_FE
                        )
                      ">
                      <span
                        style="color: red"
                        (click)="onDeleteAction(payment)"
                        (keydown)="onDeleteAction(payment)"
                        tabindex="1"
                        role="button">
                        <i class="fa fa-trash ml-2 pointer"></i>
                      </span>
                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </ng-container>

            <!-- Message to display when there are no payment records -->
            <ng-template #noPaymentRecords>
              <tr>
                <td colspan="6" class="text-center">
                  No payment records found.
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
